export const normalizeReviewProcessId = (value) => {
  const parsedId = Number(value)

  if (!Number.isInteger(parsedId) || parsedId <= 0) {
    return null
  }

  return parsedId
}

export const resolveTaskReviewProcess = (task) => {
  if (!task || typeof task !== 'object') {
    return null
  }

  return task.review_process ?? task.reviewProcess ?? null
}

export const hasTaskReviewProcess = (task) => {
  return normalizeReviewProcessId(resolveTaskReviewProcess(task)?.id) !== null
}
